import {setUser} from '../slices/userSlice';
import {setScreen} from '../slices/tabSlice';
import {addToCart} from '../slices/cartSlice';
import {resetCart} from '../slices/cartSlice';
import {setDiscount} from '../slices/cartSlice';
import {setPromoCode} from '../slices/cartSlice';
import {resetFilters} from '../slices/filterSlice';
import {removeFromCart} from '../slices/cartSlice';
import {addToWishlist} from '../slices/wishlistSlice';
import {setSelectedColors} from '../slices/filterSlice';
import {setSelectedRatings} from '../slices/filterSlice';
import {setFirstLaunch} from '../slices/firstLaunchSlice';
import {setSelectedPotTypes} from '../slices/filterSlice';
import {removeFromWishlist} from '../slices/wishlistSlice';
import {setSelectedCategories} from '../slices/filterSlice';
import {setSelectedPlantTypes} from '../slices/filterSlice';
import {setPhoneVerified} from '../slices/verificationSlice';
import {setEmailVerified} from '../slices/verificationSlice';

export const actions = {
  setUser,
  setScreen,
  addToCart,
  resetCart,
  setDiscount,
  resetFilters,
  setPromoCode,
  addToWishlist,
  removeFromCart,
  setFirstLaunch,
  setPhoneVerified,
  setEmailVerified,
  setSelectedColors,
  removeFromWishlist,
  setSelectedRatings,
  setSelectedPotTypes,
  setSelectedCategories,
  setSelectedPlantTypes,
};
